var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-row", { staticClass: "main-frame" }, [
    _vm.element.frameLinks.src
      ? _c("div", { staticClass: "main-frame" }, [
          _vm.frameShow
            ? _c("iframe", {
                staticClass: "main-frame",
                attrs: {
                  id: "iframe",
                  src: _vm.element.frameLinks.src,
                  scrolling: "auto",
                  frameborder: "0",
                },
                on: { load: _vm.loaded, error: _vm.onError },
              })
            : _vm._e(),
          _vm.editMode === "edit"
            ? _c("div", { staticClass: "frame-mask edit-mask" }, [
                _c("span", { staticStyle: { opacity: "1" } }, [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-weight": "bold",
                        color: "lawngreen",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("panel.edit_web_tips")))]
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.editMode !== "edit"
            ? _c("div", { staticClass: "frame-mask preview-top-mask" })
            : _vm._e(),
          _vm.editMode !== "edit"
            ? _c("div", { staticClass: "frame-mask preview-right-mask" })
            : _vm._e(),
          _vm.editMode !== "edit"
            ? _c("div", { staticClass: "frame-mask preview-left-mask" })
            : _vm._e(),
          _vm.screenShot ? _c("div", { staticClass: "frame-mask" }) : _vm._e(),
        ])
      : _c("div", { staticClass: "info-class" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("panel.link_add_tips_pre")))]),
          _c("i", { staticClass: "icon iconfont icon-chaolianjie" }),
          _c("span", [_vm._v(_vm._s(_vm.$t("panel.web_add_tips_suf")))]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }